/* unplugin-vue-components disabled */import script from "./Industry.vue?vue&type=script&setup=true&lang=js"
export * from "./Industry.vue?vue&type=script&setup=true&lang=js"

import "./Industry.vue?vue&type=style&index=0&id=82eadc60&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82eadc60"]])

export default __exports__